import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ViewPartidaAmistosaDTO } from "@/interfaces/Partidas";
import { formatFechaSpaWhitoutAsync } from "@/utils/Fecha";
import CardPartidaLectura from "@/components/Commons/CardPartidaLectura.vue";

//eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'ValidadasMatchCard',
  props: {
    match: {},
    idUsuario: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CardPartidaLectura, {
    contexto: _ctx.match.esElo ? 'ELO' : '',
    fecha: _unref(formatFechaSpaWhitoutAsync)(_ctx.match.fechaPartida),
    jugador1: {
      idUsuario: _ctx.match.idUsuario1,
      nick: _ctx.match.nickUsuario1,
      ejercito: _ctx.match.ejercitoUsuario1,
      puntos: _ctx.match.resultadoUsuario1,
    },
    jugador2: {
      idUsuario: _ctx.match.idUsuario2,
      nick: _ctx.match.nickUsuario2,
      ejercito: _ctx.match.ejercitoUsuario2,
      puntos: _ctx.match.resultadoUsuario2,
    },
    escenario: _ctx.match.escenarioPartida,
    puntosPartida: _ctx.match.puntosPartida,
    idGanador: _ctx.match.ganadorPartida,
    idUsuarioDestacado: _ctx.idUsuario
  }, null, 8, ["contexto", "fecha", "jugador1", "jugador2", "escenario", "puntosPartida", "idGanador", "idUsuarioDestacado"]))
}
}

})